import * as React from 'react';
import { CoherenceNav, INavLinkGroup } from '@coherence-design-system/controls/lib/nav';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import {
  UserEvent,
  EventType,
  UsageEventName,
} from '@micro-frontend-react/employee-experience/lib/UsageTelemetry';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useCoherenceNavGroups } from './useCoherenceNavGroups';

export interface INavItem {
  key: string;
  name: string;
  href: string;
  icon: string;
  bundleLocation: string;
  componentName: string;
}

export default function Nav(): React.ReactElement {
  const homeItem: INavItem = {
    key: 'Letters',
    name: 'Letters',
    href: '/',
    icon: 'Home',
    bundleLocation: 'Letters',
    componentName: 'Letters',
  };
  const hrWeb: INavItem = {
    key: 'HRWeb',
    name: 'HRWeb',
    href: 'https://aka.ms/hrweb',
    icon: 'HRWeb',
    bundleLocation: '',
    componentName: 'HRWeb',
  };
  const navLink: INavLinkGroup = {
    key: 'main',
    links: [homeItem, hrWeb],
  };
  const { telemetryClient } = React.useContext(
    Context as React.Context<IEmployeeExperienceContext>
  );

  const onToggle = (isOpen: boolean) => {
    
    // The below code is commented due to an issue with the nav bar continuously executing the "onNavCollapsed" event

    // const navigationEvent: UserEvent = {
    //   subFeature: `Navigation.SideNav.${isOpen ? 'Open' : 'Close'}`,
    //   type: EventType.User,
    //   eventName: UsageEventName.LinkClicked,
    // };

    // telemetryClient.trackEvent(navigationEvent);
  };

  const navGroup: INavLinkGroup[] = [navLink];
  const coherenceNavGroups = useCoherenceNavGroups(navGroup);

  return (
    <CoherenceNav
      groups={coherenceNavGroups}
      onNavCollapsed={(isOpen: boolean) => onToggle(isOpen)}
      defaultIsNavCollapsed={true}
      telemetryHook={telemetryClient}
      styles={{
        mobileNavWrapper: {
          marginTop: '52px',
        },
      }}
    />
  );
}
